var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrdDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.05859H3.89472L6.2105 16.6142H18.3683C19.6473 16.6142 20.6841 17.609 20.6841 18.8364C20.6841 20.0637 19.6473 21.0586 18.3683 21.0586C17.0893 21.0586 16.0526 20.0637 16.0526 18.8364M9.10522 3.28082H23L20.6842 9.94748M19.5262 13.2808H5.71424M11.421 18.8364C11.421 20.0637 10.3842 21.0586 9.10522 21.0586C7.82625 21.0586 6.78944 20.0637 6.78944 18.8364C6.78944 17.609 7.82625 16.6142 9.10522 16.6142C10.3842 16.6142 11.421 17.609 11.421 18.8364Z",
    stroke: "#6AA13C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdDetails);
export default __webpack_public_path__ + "static/media/ord-details.f4cda38a05c0918ed13e1d8b711bea80.svg";
export { ForwardRef as ReactComponent };